import { AxiosResponse } from 'axios';
import { stringify } from 'query-string';

import { BankDetails, Country, GusCompanyData, ListPagination, NfzOffice, TaxOffice, TaxOfficesRequestParams } from '../../interfaces/api';
import { phpApi } from '../default';

export const getCompanyFromGusByNip: (nip: string) => Promise<AxiosResponse<GusCompanyData>> = (
  nip: string
): Promise<AxiosResponse<GusCompanyData>> => phpApi.get(`/api/gov-services/company/${nip}`);

export const getNfzOffices: () => Promise<AxiosResponse<NfzOffice[]>> = (): Promise<AxiosResponse<NfzOffice[]>> =>
  phpApi.get('/api/gov-services/nfz');

export const getBankAccountNumberOfficeName: (bankAccountNumber: string) => Promise<AxiosResponse<BankDetails>> = (
  bankAccountNumber: string
): Promise<AxiosResponse<BankDetails>> => phpApi.get(`/api/gov-services/bank/${bankAccountNumber}`);

export const getTaxOffices: (params: TaxOfficesRequestParams) => Promise<AxiosResponse<ListPagination<TaxOffice>>> = (
  params: TaxOfficesRequestParams
): Promise<AxiosResponse<ListPagination<TaxOffice>>> =>
  phpApi.get(`/api/gov-services/tax-offices?${stringify(params, { skipEmptyString: true })}`);

export const getCountries: () => Promise<AxiosResponse<Country[]>> = (): Promise<AxiosResponse<Country[]>> =>
  phpApi.get('/api/gov-services/countries');
